const EditIcon = ({ color, onClick }) => {
  const stroke = color ? color : "white";
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M8.20999 2.76684C8.64468 2.29587 8.86202 2.06039 9.09298 1.92303C9.65026 1.5916 10.3365 1.5813 10.903 1.89585C11.1378 2.02621 11.3619 2.25506 11.8099 2.71277C12.258 3.17048 12.482 3.39933 12.6096 3.6392C12.9175 4.21798 12.9075 4.91895 12.583 5.48824C12.4486 5.72417 12.218 5.94619 11.757 6.39025L6.27152 11.6737C5.39784 12.5152 4.96099 12.9359 4.41503 13.1492C3.86906 13.3624 3.26886 13.3467 2.06845 13.3153L1.90513 13.3111C1.53969 13.3015 1.35697 13.2967 1.25075 13.1762C1.14454 13.0556 1.15904 12.8695 1.18804 12.4973L1.20379 12.2951C1.28541 11.2474 1.32623 10.7235 1.53082 10.2526C1.73542 9.78171 2.08833 9.39935 2.79416 8.63462L8.20999 2.76684Z"
        stroke={stroke}
        stroke-width="0.875"
        stroke-linejoin="round"
      />
      <path
        d="M7.58301 2.83301L11.6663 6.91634"
        stroke={stroke}
        stroke-width="0.875"
        stroke-linejoin="round"
      />
      <path
        d="M8.16699 13.333L12.8337 13.333"
        stroke={stroke}
        stroke-width="0.875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
